/**
 * AIM Color Selectors V2 — multi-select swatch grid per material group.
 * Rules: min 1 color per group; max = group cap (data-cap). No overall total cap.
 * Line items: properties[<group label>] = "A, B" + properties[Mix] = blend label.
 */
(function () {
  var container = document.querySelector('[data-aim-v2]');
  if (!container) return;

  var formId = container.getAttribute('data-form-id');
  var minQuantity = parseInt(container.getAttribute('data-min-quantity'), 10) || 0;
  var form = document.getElementById(formId);
  if (!form) form = document.querySelector('form[id*="product-form-"]');
  if (!form) return;

  // ── swatch fallback map (same values as live theme's color-selectors.js) ──
  var fallback = {
    'Apple Green': '#8DB600', 'Black': '#0A0A0A', 'Blue': '#1565C0', 'Boysenberry': '#873260',
    'Claret': '#7F1734', 'Green': '#2E7D32', 'Grey': '#9E9E9E', 'Harvest Gold': '#DA9100',
    'Hot Pink': '#FF69B4', 'Ivory': '#FFFFF0', 'Khaki': '#C3B091', 'Kraft Brown': '#A0522D',
    'Lavender': '#B57EDC', 'Limon': '#C7F000', 'Mandarin Red': '#E64A19', 'Midnight Blue': '#191970',
    'Orange': '#FF9800', 'Pink': '#FFC0CB', 'Purple': '#7B1FA2', 'Scarlet Red': '#FF2400',
    'Teal': '#008080', 'Turquoise': '#40E0D0', 'White': '#FFFFFF', 'Yellow': '#FFEB3B',
    'DayGlo Green': '#39FF14', 'DayGlo Limon': '#CCFF00', 'DayGlo Pink': '#FF6EC7', 'DayGlo White': '#FFFFF0',
    'Glimmer Gold': '#FFD700', 'Glimmer Silver': '#C0C0C0',
    'Metallic Black': '#1A1A1A', 'Metallic Blue': '#1E90FF', 'Metallic Clear': '#F0F0F0',
    'Metallic Copper-Bronze': '#CD7F32', 'Metallic Gold': '#FFD700', 'Metallic Green': '#32CD32',
    'Metallic Holographic': '#E8E8E8', 'Metallic Mearl': '#F5F5DC', 'Metallic Orange': '#FF8C00',
    'Metallic Pink': '#FF69B4', 'Metallic Purple': '#9B30FF', 'Metallic Red': '#DC143C',
    'Metallic Silver': '#C0C0C0', 'Metallic Teal': '#20B2AA', 'Metallic White': '#F8F8FF',
    'DayGlo Film Blue': '#4169E1', 'DayGlo Film Green': '#32CD32', 'DayGlo Film Orange': '#FF8C00',
    'DayGlo Film Pink': '#FF69B4', 'DayGlo Film Purple': '#9B30FF', 'DayGlo Film Yellow': '#FFD700',
    'Technoflek Black': '#1A1A1A', 'Technoflek Blue': '#4169E1', 'Technoflek Copper': '#B87333',
    'Technoflek Gold': '#FFD700', 'Technoflek Green': '#32CD32', 'Technoflek Mearl': '#F5F5DC',
    'Technoflek Orange': '#FF8C00', 'Technoflek Pink': '#FF69B4', 'Technoflek Purple': '#9B30FF',
    'Technoflek Red': '#DC143C', 'Technoflek Silver': '#C0C0C0', 'Technoflek White': '#F8F8FF',
    'CleanFree White': '#FFFFFF', 'Holographic': '#E8E8E8'
  };
  var LABELS = { 1: 'Solid color', 2: '50 / 50 blend', 3: 'Even three-way blend', 4: 'Even four-way blend' };
  var MIX = { 1: 'Solid', 2: '50 / 50', 3: 'Even three-way', 4: 'Even four-way' };
  var SHARES = { 1: '100%', 2: '50%', 3: '~33%', 4: '25%' };

  var groups = Array.prototype.map.call(
    container.querySelectorAll('[data-aim-v2-group]'),
    function (g) {
      var idx = g.getAttribute('data-aim-v2-group');
      return {
        idx: idx,
        label: g.getAttribute('data-label'),
        cap: parseInt(g.getAttribute('data-cap'), 10) || 1,
        grid: container.querySelector('[data-aim-v2-grid="' + idx + '"]'),
        helper: container.querySelector('[data-aim-v2-helper="' + idx + '"]'),
        hover: container.querySelector('[data-aim-v2-hovername="' + idx + '"]'),
        picked: []
      };
    }
  );

  var readout = container.querySelector('[data-aim-v2-readout]');
  var errEl = container.querySelector('[data-aim-v2-err]');

  function swatchCss(name) {
    if (name === 'Multicolor') {
      return 'conic-gradient(from 0deg, #ff4b4b, #ffb400, #ffe600, #3ddc6b, #00b4ff, #b44bff, #ff4b4b)';
    }
    var btn = container.querySelector('[data-aim-v2-sw][data-name="' + name + '"]');
    if (btn && btn.style.getPropertyValue('--sw-bg')) return btn.style.getPropertyValue('--sw-bg');
    var hex = fallback[name];
    return hex ? 'linear-gradient(to right, ' + hex + ', ' + hex + ')' : '#ccc';
  }

  function isLight(name) {
    var hex = fallback[name];
    if (!hex) return false;
    var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    return r >= 220 && g >= 220 && b >= 220;
  }

  // apply fallback swatch styles + light-color insets
  groups.forEach(function (g) {
    Array.prototype.forEach.call(g.grid.querySelectorAll('[data-aim-v2-sw]'), function (btn) {
      var name = btn.getAttribute('data-name');
      if (!btn.style.getPropertyValue('--sw-bg')) {
        btn.style.setProperty('--sw-bg', swatchCss(name));
      }
      if (isLight(name)) btn.style.outline = '1px solid #ddd';
    });
  });

  function totalPicked() {
    return groups.reduce(function (n, g) { return n + g.picked.length; }, 0);
  }

  function render() {
    groups.forEach(function (g) {
      var room = g.cap - g.picked.length;
      Array.prototype.forEach.call(g.grid.querySelectorAll('[data-aim-v2-sw]'), function (btn) {
        var on = g.picked.indexOf(btn.getAttribute('data-name')) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('aim-v2__sw--dim', !on && room <= 0);
      });
      if (g.picked.length && room > 0) {
        g.helper.textContent = room === 1 ? 'One more allowed.' : 'Up to ' + room + ' more.';
        g.helper.classList.remove('aim-v2__helper--error');
      } else if (room <= 0) {
        g.helper.textContent = 'Maximum ' + g.cap + '. Tap a selected color to swap it out.';
        g.helper.classList.remove('aim-v2__helper--error');
      } else {
        g.helper.textContent = 'Choose at least one.' + (g.cap > 1 ? ' Pick ' + g.cap + ' for an even blend.' : '');
        g.helper.classList.remove('aim-v2__helper--error');
      }
    });

    var total = totalPicked();
    if (!total) {
      readout.innerHTML = '<p class="aim-v2__empty">No colors selected yet</p>';
      return;
    }
    var share = SHARES[total] || '';
    var bar = '<div class="aim-v2__bar">';
    var chips = '<div class="aim-v2__chips">';
    groups.forEach(function (g) {
      g.picked.forEach(function (name) {
        bar += '<div style="background:' + swatchCss(name) + '"></div>';
        chips += '<span class="aim-v2__chip"><i style="background:' + swatchCss(name) + '"></i>' + name +
          (share ? ' <em>' + share + '</em>' : '') + '</span>';
      });
    });
    bar += '</div>'; chips += '</div>';
    var label;
    if (groups.length > 1) {
      var parts = groups.map(function (g) { return g.picked.length ? g.picked.length + ' ' + g.label.toLowerCase().replace(/s$/, '') : null; })
        .filter(Boolean);
      label = parts.join(' + ') + ' \u00b7 ' + (LABELS[total] || '').toLowerCase();
    } else {
      label = LABELS[total] || '';
    }
    readout.innerHTML = bar + '<p class="aim-v2__mixlabel">' + label + '</p>' + chips;
  }

  function toggle(g, name) {
    errEl.textContent = '';
    var at = g.picked.indexOf(name);
    if (at > -1) { g.picked.splice(at, 1); }
    else if (g.picked.length >= g.cap) {
      g.helper.textContent = 'Maximum ' + g.cap + '. Tap a selected color to swap it out.';
      g.helper.classList.add('aim-v2__helper--error');
      return;
    }
    else { g.picked.push(name); }
    render();
  }

  groups.forEach(function (g) {
    Array.prototype.forEach.call(g.grid.querySelectorAll('[data-aim-v2-sw]'), function (btn) {
      var name = btn.getAttribute('data-name');
      btn.addEventListener('click', function () { toggle(g, name); });
      btn.addEventListener('mouseenter', function () { g.hover.textContent = name; });
      btn.addEventListener('focus', function () { g.hover.textContent = name; });
      btn.addEventListener('mouseleave', function () { g.hover.textContent = ''; });
      btn.addEventListener('blur', function () { g.hover.textContent = ''; });
    });
  });

  // ── property injection ──
  function updateProperties() {
    form.querySelectorAll('[data-aim-v2-property]').forEach(function (el) { el.remove(); });
    var total = totalPicked();
    if (!total) return;
    groups.forEach(function (g) {
      if (!g.picked.length) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + g.label + ']';
      input.value = g.picked.join(', ');
      input.setAttribute('data-aim-v2-property', '');
      form.appendChild(input);
    });
    var mix = document.createElement('input');
    mix.type = 'hidden';
    mix.name = 'properties[Mix]';
    mix.value = MIX[total] || 'Even';
    mix.setAttribute('data-aim-v2-property', '');
    form.appendChild(mix);
  }

  // ── validation on buy buttons ──
  document.addEventListener('click', function (e) {
    var submitBtn = e.target.closest('buy-buttons [type="submit"], buy-buttons button[type="submit"]');
    if (!submitBtn) return;
    var buyButtons = submitBtn.closest('buy-buttons');
    if (!buyButtons || buyButtons.getAttribute('form') !== formId) return;

    var ok = true;
    groups.forEach(function (g) {
      if (!g.picked.length) {
        ok = false;
        g.helper.textContent = 'Choose at least one color.';
        g.helper.classList.add('aim-v2__helper--error');
      }
    });
    if (!ok) {
      e.preventDefault(); e.stopImmediatePropagation();
      errEl.textContent = 'Choose at least one color from each group.';
      return;
    }

    // ── min quantity validation (v1 parity) ──
    if (minQuantity > 1) {
      var qtyEl = document.getElementById(formId + '-quantity');
      var qtyVal = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!qtyVal || qtyVal < minQuantity) {
        e.preventDefault(); e.stopImmediatePropagation();
        errEl.textContent = 'Minimum order is ' + minQuantity + ' units.';
        if (qtyEl) {
          qtyEl.classList.add('aim-v2__qty-error');
          setTimeout(function () { qtyEl.classList.remove('aim-v2__qty-error'); }, 2000);
        }
        var noticeEl = container.querySelector('.aim-v2__min-notice');
        if (noticeEl) {
          noticeEl.classList.add('aim-v2__min-notice--error');
          setTimeout(function () { noticeEl.classList.remove('aim-v2__min-notice--error'); }, 2000);
        }
        return;
      }
    }

    updateProperties();
  }, true);

  // ── min quantity ──
  if (minQuantity > 1) {
    var qty = document.getElementById(formId + '-quantity');
    if (qty) { qty.value = minQuantity; qty.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  // ── hide native variant picker ──
  function hideVariantPicker() {
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) { el.style.display = 'none'; });
  }
  hideVariantPicker();
  document.addEventListener('shopify:section:load', hideVariantPicker);

  render();
})();
